import type { ReactNode } from "react";
import { cx } from "../ui/cx";
import type { SeasonLayout } from "./layout";

/**
 * The root of a Season page (`.k`): tokens, the gutter and `data-lay`, which every Season style keys off. Pass the layout
 * from `useLayout()`. A page that holds a `DockedBar` needs nothing more: the root makes room for it.
 */
export function Page({
  layout,
  narrow = false,
  className,
  children,
}: {
  layout: SeasonLayout;
  /** Centre the page at 788 px on the iPad upright, for a page that is a single column. */
  narrow?: boolean;
  className?: string;
  children: ReactNode;
}) {
  return (
    <div className={cx("k", narrow && "k-narrow", className)} data-lay={layout}>
      {children}
    </div>
  );
}
